import React from "react";

import albertineIcon from "../../assets/albertine-icon.svg";
import albertineLogo from "../../assets/albertine-logo.svg";

export const Assets = {
    albertineIcon,
    albertineLogo,
};

const Asset = function Asset(props: {
    alt?: string | undefined;
    className?: string | undefined;
    src: string;
    style?: React.CSSProperties | undefined;
    onClick?: () => void | undefined;
}) {
    const { alt, className, src, style, onClick } = props;
    return (
        <img
            src={src}
            className={className}
            alt={alt || ""}
            style={style}
            onClick={onClick}
        />
    );
};

export default React.memo(Asset);
